import { gql } from "@apollo/client";

export const LIST_VOUCHERS = gql`
	query listVouchers($page: Int, $first: Int!, $voucher: VoucherFilters) {
		listVouchers(page: $page, first: $first, voucher: $voucher) {
			paginatorInfo {
				count
				currentPage
				firstItem
				hasMorePages
				lastItem
				lastPage
				perPage
				total
			}
			data {
				id
				name
				coins
				is_active
				tier {
					id
					name
					index
				}
				codes_count
				redeemed_codes_count
			}
		}
	}
`;

export const VIEW_VOUCHER = gql`
	query showVoucher($id: ID!) {
		showVoucher(id: $id) {
			id
			name
			image {
				url
				id
			}
			coins
			is_active
			tier {
				id
				name
			}
			codes_count
			redeemed_codes_count
			roles {
				id
				name
			}
		}
	}
`;

export const GET_PLATFORM_ROLES = gql`
	query GetPlatformRoles {
		getPlatformRoles {
			value: id
			label: name
		}
	}
`;
export const LIST_TIERS = gql`
	query getTiers {
		getTiers {
			value: id
			label: name
		}
	}
`;
